var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleBgShapeSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 379,
    viewBox: "0 0 348 379",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M161.094 4C-41.0119 42.8929 -56.9594 366.837 165.073 374.85C383.411 382.731 406.792 78.5613 209.23 26.1558M209.375 26.7345C23.7854 11.3139 -69.4391 289.63 122.024 350.773C310.3 410.901 405.157 151.625 245.884 57.7784",
    stroke: "#E2E2E2",
    strokeOpacity: 0.3,
    strokeWidth: 6.27,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleBgShapeSmall);
export default __webpack_public_path__ + "static/media/circle-bg-shape-small.07c9de5d9b269daf418e412dd0fa6b0f.svg";
export { ForwardRef as ReactComponent };